import request from '@/utils/request'

// 公共广告列表
export function publicAdvertList(params) {
  return request({
    url: '/ad_management/ad_commons',
    method: 'get',
    params
  })
}

// 公共广告详情接口
export function publicAdvertDetail(id) {
  return request({
    url: `/ad_management/ad_commons/${id}`,
    method: 'get'
  })
}

// 删除公共广告计划
export function deletePublicAdvert(id) {
  return request({
    url: `/ad_management/ad_commons/${id}`,
    method: 'delete'
  })
}

// 创建公共广告计划
export function createPublicAdvert(data) {
  return request({
    url: `/ad_management/ad_commons`,
    method: 'post',
    data
  })
}

// 修改稿公共广告计划
export function modifyPublicAdvert(id, data) {
  return request({
    url: `/ad_management/ad_commons/${id}`,
    method: 'put',
    data
  })
}
